export default "__VITE_ASSET__TqjVca4i__"